// extracted by extract-css-chunks-webpack-plugin
module.exports = {"colResults":"_3WhuuY","header":"_2hrW4L"};